import {
  CoreContextmenu,
  CoreContextmenuItem
} from '@komodo-design-system/komodo-components-react';
import React, { useEffect } from 'react';

interface ActionPopUpProps {
  action: {
    isOpen: boolean;
    inputProps?: { original_file_path?: string; file_status?: string; 'ARTESIA.FIELD.MIME TYPE'?: string };
    iconRef: string;
  };
  handleAction: (action: string, inputProps?: object) => void;
}

const ActionPopUp: React.FC<ActionPopUpProps> = ({ action, handleAction }) => {
  const { isOpen, inputProps, iconRef } = action;
  const { original_file_path, file_status } = (inputProps || {}) as { original_file_path?: string, file_status?: string };
  const mimeType = inputProps?.['ARTESIA.FIELD.MIME TYPE'];
  const element = document.getElementById(iconRef);
  const divRef = React.useRef<HTMLDivElement>(null);
  const [menuOptions, setMenuOptions] = React.useState<Array<{ label: string; value: string }>>([]);
  const style = {
    position: 'absolute',
    top: element ? element.getBoundingClientRect().bottom + window.scrollY : 0,
    left: element
      ? element.getBoundingClientRect().left - 200 + window.scrollX
      : 0
  };
  const currentPage = window.location.pathname;
  const isEdit=currentPage?.includes('asset-edit');
  const isDetail=currentPage?.includes('asset-detail');
  const isCheckIn=currentPage?.includes('asset-check-in');
  const isJobDetails=currentPage?.includes('job-detail');
  // useEffect to handle click outside of the popup
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (divRef.current && !divRef.current.contains(event.target as Node)) {
        handleAction('close');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleAction]);

  useEffect(() => {
    const fetchMenuOptions = () => {
      let dropdownOptions: Array<{
        label: string;
        value: string;
      }> = [
      ];
      
      // For JobDetails page, only show View and Edit options
      if (isJobDetails) {
        dropdownOptions.push({label: 'View', value: 'view'});
        dropdownOptions.push({label: 'Edit', value: 'edit'});
      } else {
        // Original logic for other pages
        if(!isDetail) {
          dropdownOptions.push({label: 'View', value: 'view'});
        }
        if(!isEdit) {
          dropdownOptions.push({label: 'Edit', value: 'edit'});
        }
        if((original_file_path || mimeType) && !isCheckIn) {
          dropdownOptions.push({label: 'Check-out', value: 'checkIn'});
        }
        if(!file_status?.toLowerCase().includes('inprogress')) {
          dropdownOptions.push({label: 'Publish', value: 'publish'});
          dropdownOptions.push({label: 'Unpublish', value: 'unpublish'});
        }
        if(mimeType){
          dropdownOptions.push({label: 'Download', value: 'download'});
        }
      }
      
      setMenuOptions(dropdownOptions);
    };
    if (isOpen) {
      fetchMenuOptions();
    }
  }, [isOpen]);

  return (
    <div
      className="action-popup"
      style={style as React.CSSProperties}
      ref={divRef}>
      <CoreContextmenu open={isOpen}>
        {menuOptions.map(({ label, value }, index) => (
          <CoreContextmenuItem
            key={index}
            onClick={() => handleAction(value, inputProps)}
            label={label}
          >
          </CoreContextmenuItem>
        ))}
        {/* <CoreContextmenuItem onClick={() => handleAction('close')} label='Close'>
        </CoreContextmenuItem> */}
      </CoreContextmenu>
    </div>
  );
};

export default ActionPopUp;